import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAmplifyUser } from 'data/types/Amplify.types';
import { authApi } from '../apiSlice/auth.slice';

export type TAuthSliceState = {
  amplifyUser: TAmplifyUser | null;
};

const initialState: TAuthSliceState = {
  amplifyUser: localStorage.getItem('amplifyUser')
    ? JSON.parse(localStorage.getItem('amplifyUser') as string)
    : null,
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setAmplifyUser(state, action: PayloadAction<TAmplifyUser>) {
      state.amplifyUser = action.payload;
      localStorage.setItem('amplifyUser', JSON.stringify(action.payload));
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(
        authApi.endpoints.signIn.matchFulfilled,
        (state, { payload }) => {
          if ('challengeName' in payload) {
            return;
          }
          state.amplifyUser = payload;
          localStorage.setItem('amplifyUser', JSON.stringify(payload));
        },
      )
      .addMatcher(authApi.endpoints.signOut.matchFulfilled, state => {
        state.amplifyUser = null;
      });
  },
});

export default authSlice;
